import React from "react"

import {
  CheckboxContainer,
  CheckboxLabel,
  CheckboxWrapper,
  HiddenCheckbox,
  Icon,
  StyledCheckbox,
} from "./styled"
import type { CheckboxProps } from "./types"

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  label,
  onChange,
  ...props
}) => {
  return (
    <CheckboxWrapper>
      <CheckboxContainer>
        <HiddenCheckbox checked={checked} onChange={onChange} {...props} />
        <StyledCheckbox checked={!!checked}>
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxContainer>
      <CheckboxLabel>{label}</CheckboxLabel>
    </CheckboxWrapper>
  )
}

export default Checkbox
